import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "add-role-form" }
const _hoisted_2 = {
  key: 0,
  class: "loading apollo"
}

import { ref, computed } from "vue";
import { useI18n } from "vue-i18n";
import { useToast } from "vue-toastification";
import { useMutation } from "@vue/apollo-composable";
import { logErrorMessages } from "@vue/apollo-util";

import Modal from "@/components/Modal.vue";
import FormItem from "@/components/form/FormItem.vue";
import BasicButton from "@/components/BasicButton.vue";

import { ADD_DEFAULT_ROLE } from "@/graphql/defaultRole/mutations";

import { GET_DEFAULT_ROLES } from "@/graphql/defaultRole/queries";

import enUK from "@/locales/en-UK.json";


export default /*@__PURE__*/_defineComponent({
  __name: 'AddRoles',
  emits: ["close"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const { t } = useI18n({
  useScope: "global",
  inheritLocale: true,
  messages: {
    "en-UK": enUK,
  },
});

const toast = useToast();

const newRoleName = ref("");
const newRoleHourlyRate = ref<number | string>("");

const {
  mutate: addRole,
  onError: onAddRoleError,
  onDone: onAddRoleDone,
  loading: addingRole,
} = useMutation(ADD_DEFAULT_ROLE, {
  refetchQueries: [{ query: GET_DEFAULT_ROLES }],
});

onAddRoleError((error) => {
  logErrorMessages(error);
  toast.error(t("errors.addDefaultRole"));
});

onAddRoleDone(() => {
  toast.success(t("success.addDefaultRole"));
  emit("close");
});

const isLoading = computed(() => addingRole.value);

async function handleAddRole(): Promise<void> {
  if (!newRoleName.value || !newRoleHourlyRate.value) {
    toast.error(t("errors.requiredFields"));
    return;
  }

  const hourlyRateInCents =
    typeof newRoleHourlyRate.value === "string"
      ? Math.round(parseFloat(newRoleHourlyRate.value) * 100)
      : newRoleHourlyRate.value;

  if (isNaN(hourlyRateInCents)) {
    toast.error(t("errors.invalidHourlyRate"));
    return;
  }

  await addRole({
    name: newRoleName.value,
    hourlyRate: hourlyRateInCents,
  });
}

function closeModal(): void {
  emit("close");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, { onClose: closeModal }, {
    header: _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(t)("titles.role.add")), 1)
    ]),
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(FormItem, {
          input: newRoleName.value,
          "onUpdate:input": _cache[0] || (_cache[0] = ($event: any) => ((newRoleName).value = $event)),
          label: _unref(t)('labels.role'),
          name: "name",
          "input-type": "basic"
        }, null, 8, ["input", "label"]),
        _createVNode(FormItem, {
          input: newRoleHourlyRate.value,
          "onUpdate:input": _cache[1] || (_cache[1] = ($event: any) => ((newRoleHourlyRate).value = $event)),
          label: _unref(t)('labels.hourlyRate'),
          name: "hourlyRate",
          "input-type": "basic"
        }, null, 8, ["input", "label"])
      ]),
      (isLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_unref(t)("loading")), 1))
        : _createCommentVNode("", true)
    ]),
    footer: _withCtx(() => [
      _createVNode(BasicButton, {
        class: "add-button",
        type: "submit",
        disabled: isLoading.value,
        onClick: handleAddRole
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)("buttons.addRoles")), 1)
        ]),
        _: 1
      }, 8, ["disabled"]),
      _createVNode(BasicButton, {
        class: "cancel-button",
        onClick: closeModal
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)("buttons.cancel")), 1)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})